export default "__VITE_ASSET__DFIs5GUt__"